<template>
  <!-- Zielordner in der Akte (Kundenfeedback 18.10.2026, XX): nur die Ordner,
       die die Akte tatsächlich hat, und getrennt die Vorlagen, die beim
       Ablegen angelegt werden. Die Gruppen liefert useFolderTargets. -->
  <label class="cfs" :class="{ 'cfs--compact': compact }">
    <span v-if="!compact" class="cfs__label">
      {{ label || $gt('Ablageordner in der Akte') }}
      <span v-if="loading" class="cfs__hint">{{ $gt('(Ordner werden geladen…)') }}</span>
    </span>
    <select
      :aria-label="label || $gt('Ablageordner in der Akte')"
      class="cfs__select"
      :disabled="disabled || loading || groups.length === 0"
      :value="modelValue"
      @change="onChange"
    >
      <option v-if="!modelValue" disabled value="">{{ loading ? $gt('Ordner werden geladen…') : $gt('Ordner wählen') }}</option>
      <optgroup v-for="group in groups" :key="group.label" :label="group.label">
        <option v-for="opt in group.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </optgroup>
    </select>
  </label>
</template>

<script setup lang="ts">
  import type { FolderGroup } from './caseFolders'

  defineProps<{
    modelValue: string
    groups: FolderGroup[]
    label?: string
    disabled?: boolean
    loading?: boolean
    /** Ohne Beschriftung, schmal – für Zeilen in der Anhangsliste. */
    compact?: boolean
  }>()
  const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

  function onChange (event: Event) {
    emit('update:modelValue', (event.target as HTMLSelectElement).value)
  }
</script>

<style scoped>
.cfs { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.cfs__label { font-size: 0.74rem; font-weight: 600; color: var(--grey-color); }
.cfs__hint { margin-left: 4px; font-weight: 400; }
.cfs__select {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid var(--border-grey-color);
  border-radius: 10px;
  background: #fff;
  font-size: 0.84rem;
  color: var(--dark-color);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.cfs--compact .cfs__select { height: 32px; border-radius: 8px; font-size: 0.8rem; }
.cfs__select:hover:not(:disabled) { border-color: #9fb3c8; }
.cfs__select:focus { outline: none; border-color: var(--primary-color); box-shadow: 0 0 0 3px rgba(0, 118, 229, 0.14); }
.cfs__select:disabled { opacity: 0.6; }
</style>
